module.exports = __webpack_public_path__ + "static/media/restaurant (1).87080b31.jpg";